import { useState, useEffect } from 'react';

export function useCravings(user: any) {
  const [cravedIds, setCravedIds] = useState<Set<number>>(new Set());

  useEffect(() => {
    if (user?.isLogged && user?.token) {
      fetch(`${process.env.REACT_APP_SERVER_URL}/cravings`, {
        headers: { Authorization: 'Bearer ' + user.token },
      })
        .then(r => r.json())
        .then((ids: number[]) => setCravedIds(new Set(ids || [])))
        .catch(() => setCravedIds(new Set()));
    } else {
      setCravedIds(new Set());
    }
  }, [user?.isLogged, user?.token]);

  const handleToggleCraving = (itemId: number) => {
    if (!user?.isLogged) return;
    setCravedIds(prev => {
      const next = new Set(prev);
      next.has(itemId) ? next.delete(itemId) : next.add(itemId);
      return next;
    });
    fetch(`${process.env.REACT_APP_SERVER_URL}/cravings/toggle`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + user.token,
      },
      body: JSON.stringify({ itemId: itemId }),
    }).catch(() => {
            // craving update: revert optimistic update and alert user on failure
            setCravedIds(prev => {
              const next = new Set(prev);
              next.has(itemId) ? next.delete(itemId) : next.add(itemId);
              return next;
            });
            alert('Failed to update craving. Please try again.');
          });
  };

  return { cravedIds, handleToggleCraving };
}